import { cn } from "@portal/components/lib/utils";
import { PartialIndicator } from "@portal/components/primitives";
import { RequiredForApprovalIndicator } from "@portal/components/ui/RequiredForApprovalIndicator";
import { ReactNode } from "react";
import { formatEmpty } from "../../../utils";

export type AdminDataListProps = {
	data: {
		label: string;
		value?: string | ReactNode | null;
		partial?: boolean;
		requiredForApproval?: boolean;
		bypassValueCheck?: boolean;
	}[];
	// Ignored when `bare` is true — there's no wrapper to apply it to
	className?: string;
	rowClassName?: string;
	bare?: boolean;
};

export const AdminDataList = ({ data, className, rowClassName, bare }: AdminDataListProps) => {
	const rows = data.map((item, index) => {
		const missingValue = item.bypassValueCheck
			? true
			: Array.isArray(item.value)
				? !item.value.length
				: !item.value;
		return (
			<div
				key={index}
				className={cn("flex items-center py-[14px] px-[10px] space-x-[10px]", rowClassName)}
			>
				<div className="text-primary text-[14px] font-medium">{item.label}</div>
				<div
					className={cn(
						"flex items-center justify-end flex-1",
						// Matches ViewSectionCardEditItem's value styling only when nested via `bare`.
						bare ? "text-primary text-[15px]" : "text-secondary",
					)}
				>
					{formatEmpty(item.value)}
					{missingValue && item.requiredForApproval ? (
						<RequiredForApprovalIndicator active={item.requiredForApproval} className="ml-[5px]" />
					) : missingValue && item.partial ? (
						<PartialIndicator active={item.partial} className="ml-[5px]" />
					) : null}
				</div>
			</div>
		);
	});

	if (bare) return <>{rows}</>;

	return (
		<div className={cn("flex flex-col w-full divide-y divide-bc-default text-[14px]", className)}>
			{rows}
		</div>
	);
};
